import { render, staticRenderFns } from "./Municipio.vue?vue&type=template&id=e1dfcd54&scoped=true"
import script from "./Municipio.js?vue&type=script&lang=js&external"
export * from "./Municipio.js?vue&type=script&lang=js&external"
import style0 from "./Municipio.vue?vue&type=style&index=0&id=e1dfcd54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1dfcd54",
  null
  
)

export default component.exports